const SERVER_HOST = 'https://api.chemhub.org/';
//const SERVER_HOST = 'http://localhost:5000';

export default SERVER_HOST;